"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributorSanctionManagement = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.DistributorSanctionManagement = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.distributor_sanction_management.label',
    fallbackLabel: 'Do you fully and exclusively depend on sanction controls, such as name sanction screening and transaction sanction screening, conducted by your Distributors?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.entrust_other_contracted_entities', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.Boolean,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.entrust_other_contracted_entities === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.entrust_other_contracted_entities === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
